/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

// Scripts
import $ from "jquery";
import "sections/header/header";
import "sections/footer/footer";
import "sections/page-header/page-header";

// Styles
import "./_login.scss";

const selectors = {
    recoverPasswordForm: ".js-recoverPassword",
    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
};

function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
}

function checkUrlHash() {
    const hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === "#recover") {
        toggleRecoverPasswordForm();
    }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
    $("#RecoverPasswordForm").toggleClass("hide");
    $("#CustomerLoginForm").toggleClass("hide");
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
    const $formState = $(".reset-password-success");

    // check if reset password form was successfully submited.
    if (!$formState.length) {
        return;
    }

    // show success message
    $("#ResetSuccess").removeClass("hide");
}

function switchButtonState() {
    $(".form--login .form__input--button-state").on("input", function () {
        const $currentForm = $(this).parents(".form"),
            $submitButton = $currentForm.find(".button--submit");

        var isValid = true;
        $currentForm.find(".form__input--button-state").each(function () {
            if ($(this).val() == "") {
                isValid = false;
                return false;
            }
        });

        if (isValid) {
            $submitButton.prop("disabled", false);
        } else {
            $submitButton.prop("disabled", true);
        }
    });
}

if ($(selectors.recoverPasswordForm).length) {
    checkUrlHash();
    resetPasswordSuccess();

    $(selectors.recoverPasswordForm).on("click", onShowHidePasswordForm);
    $(selectors.hideRecoverPasswordLink).on("click", onShowHidePasswordForm);

    $(".page-header--account-form .js-recoverPassword").on(
        "keydown",
        function (e) {
            const key = e.key;

            if (key == "Enter") {
                onShowHidePasswordForm(e);
            }
        },
    );
}

if ($(".form__input--button-state").length) {
    switchButtonState();
}

// Updates "Sign Up" link with correct redirect params (recommended method from Shopify contact).
const signUpLinkDOM = document.getElementById("subtitleWithSignUp")
if (signUpLinkDOM) {
    const signUpLinkElement = signUpLinkDOM.getElementsByTagName("a")[0];
    const rootUrl = new URL(window.location.href);
    const checkoutUrlParam = rootUrl.searchParams.get("checkout_url");
    if (signUpLinkElement && checkoutUrlParam) {
        const currentSignUpLinkHref = signUpLinkElement.getAttribute("href");
        const hasQueryParams = currentSignUpLinkHref.includes("?");
        const signUpLinkWithRedirect = `${currentSignUpLinkHref}${
            hasQueryParams ? "&" : "?"
        }checkout_url=${checkoutUrlParam}`;
        signUpLinkElement.setAttribute("href", signUpLinkWithRedirect);
    }

    // Shows gift card activation message if `activate-gift-card` is in the checkout_url redirect.
    if (checkoutUrlParam && checkoutUrlParam.includes("activate-gift-card")) {
        $("#GiftCardActivationMessage").removeClass("hide");
    }
}
